import React from 'react';
import { Container, Box, Typography, Divider, Link } from '@mui/material';
import {
  TERMS_META,
  TERMS_SECTIONS,
  fillTermsTemplate,
} from '../content/termsOfService';

const headingSx = {
  fontWeight: 'bold',
  color: '#333',
  mt: 3,
  mb: 1.5,
  scrollMarginTop: { xs: 168, md: 96 },
};

const paragraphSx = {
  color: '#444',
  lineHeight: 1.85,
  mb: 1.5,
  textAlign: 'justify',
};

const Terms = () => {
  return (
    <Container sx={{ py: 4, maxWidth: 'md' }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
        Пользовательское соглашение
      </Typography>
      <Typography variant="subtitle1" sx={{ color: '#666', mb: 1 }}>
        (публичная оферта)
      </Typography>
      <Typography variant="body2" sx={{ color: '#888', mb: 3 }}>
        Редакция от {TERMS_META.revisionDate} ·{' '}
        <Link href={`${TERMS_META.siteUrl}${TERMS_META.termsPath}`} sx={{ color: '#8B7D6B' }}>
          {TERMS_META.siteUrl}{TERMS_META.termsPath}
        </Link>
      </Typography>

      <Box
        sx={{
          backgroundColor: '#F5F3F0',
          p: 2.5,
          borderRadius: 2,
          mb: 3,
        }}
      >
        <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.7 }}>
          Настоящее Соглашение регулирует использование сервиса BERLOGA: аренду оборудования, покупку
          товаров, заказ услуг и туров, работу центров выдачи и партнёрского приложения BERLOGA PRO.
          Оператор и Владелец Платформы — {TERMS_META.operatorName}, {TERMS_META.operatorStatus}.
        </Typography>
      </Box>

      {TERMS_SECTIONS.map((section, index) => (
        <Box component="section" key={section.id} id={section.id}>
          {index > 0 && <Divider sx={{ my: 2 }} />}
          <Typography variant="h6" component="h2" sx={headingSx}>
            {section.title}
          </Typography>
          {section.paragraphs.map((paragraph, pIndex) => (
            <Typography key={pIndex} variant="body1" sx={paragraphSx}>
              {fillTermsTemplate(paragraph).split('\n').map((line, lineIndex, arr) => (
                <React.Fragment key={lineIndex}>
                  {line}
                  {lineIndex < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
            </Typography>
          ))}
        </Box>
      ))}

      <Divider sx={{ my: 4 }} />

      <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.7 }}>
        По вопросам, связанным с Соглашением и работой сервиса, пишите в Telegram{' '}
        <Link
          href={TERMS_META.supportTelegram}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#8B7D6B', fontWeight: 600 }}
        >
          {TERMS_META.supportTelegramHandle}
        </Link>
        .
      </Typography>
    </Container>
  );
};

export default Terms;
